var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-none d-md-block" },
    [
      _c("checkout-stepper", {
        model: {
          value: _vm.steps,
          callback: function ($$v) {
            _vm.steps = $$v
          },
          expression: "steps",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }